// extracted by mini-css-extract-plugin
var _1 = "VDAs3B6fvQAaGtxsOedq";
var _2 = "gFnCD6Camrx5QZXw9PkQ";
var _3 = "VfKidGBiHsH8tKzrOYiL";
var _4 = "re_idvyBjIwYGKnVQpHV";
var _5 = "SkkXB7aIUKY3iMFmFXuv";
var _6 = "Do_JxLilv_eNWdyge6Uq";
var _7 = "E1N8a63yjWAvK_z53Xr7";
export { _1 as "actions", _2 as "cancel", _3 as "confirm", _4 as "note", _5 as "note_title", _6 as "popup", _7 as "question" }
